import axios from "axios";
const Axioscall = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default Axioscall;
